import { AccountInfo } from '@azure/msal-browser';
import { Role } from '../../../../entities/Roles';
import { Actions } from './actions';

import {
  GET_ROLE_ERROR,
  GET_ROLE_SUCCESS,
  GET_ROLE_REQUEST,
  SET_ACCOUNT,
  CLEAR_ROLE_ERROR,
  SWITCH_USER_ROLE,
} from './constants';

const initialState = {
  role: JSON.parse(localStorage.getItem('role') || 'null') as Role | null,
  account: null as null | AccountInfo,
  loading: false as boolean,
  error: null as Error | null,
  errorText: {} as any,
};

type RoleState = typeof initialState;

export const authReducer = (state: RoleState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_ROLE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_ROLE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        role: action.payload.role,
      };
    }
    case CLEAR_ROLE_ERROR: {
      return {
        ...state,
        loading: false,
        error: null,
        role: null,
      };
    }
    case GET_ROLE_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errorText: action.payload,
      };
    }
    case SET_ACCOUNT: {
      return {
        ...state,
        account: action.payload.account,
      };
    }
    case SWITCH_USER_ROLE:
      return {
        ...state,
        loading: false,
        error: null,
        role: action.payload.role,
      };
    default: {
      return state;
    }
  }
};
